<template>
  <div v-if="isValid">
    <v-main>
      <v-container>
        <v-form ref="form" lazy-validation>
          <v-flex xs12 text-xs-center>
            <v-img :src="require('../assets/hp-logo.gif')" class="my-3" contain height="200"></v-img>
          </v-flex>

          <v-flex xs12 text-xs-center>
            <h1
              class="display-2 font-weight-bold mb-3"
              align="center"
            >{{ companyName }} - ({{ event }}) {{ year }}</h1>
          </v-flex>
          <br />

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >1. Overall how would you rate the coaching session?</h2>

            <v-radio-group v-model="answers.rateCoaching" :rules="[rules.required]" row>
              <v-radio label="Excellent" value="excellent"></v-radio>
              <v-radio label="Very Good" value="verygood"></v-radio>
              <v-radio label="Good" value="good"></v-radio>
              <v-radio label="Average" value="average"></v-radio>
              <v-radio label="Poor" value="poor"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >2. I have benefitted from working with my coach.</h2>

            <v-radio-group v-model="answers.benefitted" :rules="[rules.required]" row>
              <v-radio label="Strongly agree" value="stronglyagree"></v-radio>
              <v-radio label="Agree" value="agree"></v-radio>
              <v-radio label="Unsure" value="unsure"></v-radio>
              <v-radio label="Disagree" value="disagree"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2 class="headline font-weight-bold mb-3">3. My coach and I connected very well.</h2>

            <v-radio-group v-model="answers.connected" :rules="[rules.required]" row>
              <v-radio label="Strongly agree" value="stronglyagree"></v-radio>
              <v-radio label="Agree" value="agree"></v-radio>
              <v-radio label="Unsure" value="unsure"></v-radio>
              <v-radio label="Disagree" value="disagree"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >4. My coaching session resulted in clear actions and steps for me to follow.</h2>

            <v-radio-group v-model="answers.actions" :rules="[rules.required]" row>
              <v-radio label="Strongly agree" value="stronglyagree"></v-radio>
              <v-radio label="Agree" value="agree"></v-radio>
              <v-radio label="Unsure" value="unsure"></v-radio>
              <v-radio label="Disagree" value="disagree"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >5. My expectations for the coaching programme have been met.</h2>

            <v-radio-group v-model="answers.expectations" :rules="[rules.required]" row>
              <v-radio label="Strongly agree" value="stronglyagree"></v-radio>
              <v-radio label="Agree" value="agree"></v-radio>
              <v-radio label="Unsure" value="unsure"></v-radio>
              <v-radio label="Disagree" value="disagree"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >6. What was your key takeaway from the session?</h2>

            <v-textarea
              v-model="answers.takeaway"
              name="input-7-1"
              filled
              label="Please type here..."
            ></v-textarea>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >7. Are there any ways in which we could improve this service?</h2>

            <v-textarea
              v-model="answers.improve"
              name="input-7-1"
              filled
              label="Please type here..."
            ></v-textarea>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >8. I would recommend the coaching session and would take part in future sessions if available?</h2>

            <v-radio-group v-model="answers.recommend" :rules="[rules.required]" row>
              <v-radio label="Strongly agree" value="stronglyagree"></v-radio>
              <v-radio label="Agree" value="agree"></v-radio>
              <v-radio label="Unsure" value="unsure"></v-radio>
              <v-radio label="Disagree" value="disagree"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex mb-5 xs12>
            <h2
              class="headline font-weight-bold mb-3"
            >9. Do you have any other comments or feedback you would like to share?</h2>

            <v-textarea
              v-model="answers.feedback"
              name="input-7-1"
              filled
              label="Please type here..."
            ></v-textarea>
          </v-flex>

          <v-btn block color="#b0cf3d" class="float-right mb-10" @click="save">Submit</v-btn>
        </v-form>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "./../graphql/queries";
import * as mutations from "./../graphql/mutations";
export default {
  async created() {
    var that = this;
    API.graphql(
      graphqlOperation(queries.getSurveyCoaching, {
        id: this.$route.params.id
      })
    )
      .then(result => {
        this.isValid = true;
        const survey = result.data.getSurveyCoaching;
        this.companyName = survey.company;
        this.event = survey.name;
      })
      .catch(err => {
        that.isValid = false;
      });
  },
  data: () => ({
    answers: [],
    isValid: true,
    companyName: null,
    event: null,
    year: new Date().getFullYear(),
    rules: {
      required: v => !!v || "This field is required."
    }
  }),
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        const coaching = {
          rateCoaching: this.answers.rateCoaching,
          benefitted: this.answers.benefitted,
          connected: this.answers.connected,
          actions: this.answers.actions,
          expectations: this.answers.expectations,
          takeaway: this.answers.takeaway,
          improve: this.answers.improve,
          recommend: this.answers.recommend,
          surveyCoachingFeedbackSurveyCoachingId: this.$route.params.id,
          feedback: this.answers.feedback
        };

        API.graphql(
          graphqlOperation(mutations.createSurveyCoachingFeedback, {
            input: coaching
          })
        )
          .then(res => {
            this.$router.push({ path: "/thankyou" });
          })
          .catch(err => (this.error = err.message));
      }
    }
  }
};
</script>

<style>
.v-radio {
  margin-right: 50px;
}
</style>